import { render, staticRenderFns } from "./OpenApp.vue?vue&type=template&id=81da2ada&scoped=true&"
import script from "./OpenApp.vue?vue&type=script&lang=js&"
export * from "./OpenApp.vue?vue&type=script&lang=js&"
import style0 from "./OpenApp.vue?vue&type=style&index=0&id=81da2ada&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81da2ada",
  null
  
)

export default component.exports